export interface LoadTimingMark {
  name: string;
  elapsedMs: number;
  deltaMs: number;
  data?: Record<string, unknown>;
}

declare global {
  interface Window {
    __GFH_LOAD_T0__?: number;
    __GFH_LOAD_MARKS__?: LoadTimingMark[];
    __GFH_BOOT_SHELL_SHOWN_AT__?: number;
  }
}

let lastMarkMs = 0;

function originMs(): number {
  if (window.__GFH_LOAD_T0__ == null) {
    window.__GFH_LOAD_T0__ = performance.now();
  }
  return window.__GFH_LOAD_T0__;
}

export function markLoad(name: string, data?: Record<string, unknown>): LoadTimingMark {
  const elapsedMs = Math.round(performance.now() - originMs());
  const deltaMs = lastMarkMs ? elapsedMs - lastMarkMs : elapsedMs;
  lastMarkMs = elapsedMs;

  const entry: LoadTimingMark = { name, elapsedMs, deltaMs, data };
  window.__GFH_LOAD_MARKS__ = [...(window.__GFH_LOAD_MARKS__ ?? []), entry];

  console.info(`[GFH LOAD] ${name} @ ${elapsedMs}ms (+${deltaMs}ms)`, data ?? '');
  return entry;
}

export function getLoadTimingSummary(): LoadTimingMark[] {
  return [...(window.__GFH_LOAD_MARKS__ ?? [])];
}

export function getNavigationTimingSnapshot(): Record<string, number> | null {
  const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (!nav) {
    return null;
  }

  return {
    dnsMs: Math.round(nav.domainLookupEnd - nav.domainLookupStart),
    connectMs: Math.round(nav.connectEnd - nav.connectStart),
    tlsMs: Math.round(nav.requestStart - nav.secureConnectionStart),
    ttfbMs: Math.round(nav.responseStart - nav.requestStart),
    downloadMs: Math.round(nav.responseEnd - nav.responseStart),
    domInteractiveMs: Math.round(nav.domInteractive),
    domContentLoadedMs: Math.round(nav.domContentLoadedEventEnd),
    loadEventMs: Math.round(nav.loadEventEnd),
    transferSize: nav.transferSize,
    encodedBodySize: nav.encodedBodySize,
  };
}
